import script from "./HeaderText.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderText.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderText.vue?vue&type=style&index=0&id=56aeaa35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56aeaa35"]])

export default __exports__